import {EntityResourceIds} from '@dms/api/shared';
import {featureFlags} from '@dms/feature-flags';
import {ActivitySidebarAction, ActivitySidebarV2} from '@dms/features/activity-panel';
import {buildCustomNoticesSidebarAction} from '@dms/features/custom-notices';

import {buildArray} from 'shared/web';

interface TireOrderActivityPanelProps {
  tireOrderId: string;
}

export function TireOrderActivityPanel(props: TireOrderActivityPanelProps) {
  const actions = buildArray<ActivitySidebarAction>().whenFeatureEnabled(
    featureFlags.CUSTOM_NOTICES,
    buildCustomNoticesSidebarAction({
      resourceId: EntityResourceIds.tireOrder,
      recordId: props.tireOrderId,
    })
  );

  return <ActivitySidebarV2 actions={actions} />;
}
